export default {
  projectId: 'dgk-teaser-app-dev',
  databaseURL: 'https://dgk-teaser-app-dev.firebaseio.com'
}
